import { Component } from "@angular/core";
import { FieldType } from "@ngx-formly/material";
import { FieldTypeConfig } from "@ngx-formly/core";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-botwm-formly",
  templateUrl: "./botwm-formly.component.html",
  styleUrls: ["./botwm-formly.component.scss"],
  imports: [MatButton, TranslatePipe],
})
export class BotwmFormlyComponent extends FieldType<FieldTypeConfig> {
  onClick($event: any) {
    if (this.props.onClick) {
      this.props.onClick($event);
    }
  }
}
